import CreateUser from './CreateUser';

export default CreateUser;
